export const environment = {
  production: true,
  apiUrl: 'https://recrutamentoetico.pt/api/v1',
  appUrl: 'https://recrutamentoetico.pt',
};
